import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_TAX_PAYEE } from "..";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { OnboardingModule } from "../types";
import { useRequirementsListQuery } from "../../../query/requirements/queries/useRequirementsListQuery";
import { useUserId } from "../../../query/hooks/helpers";
import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";

export const RouteTaxPayeeOnboarding: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();

  const queryRequirements = useRequirementsListQuery({
    filter: {
      payeeId: userId,
      payerPayeeEngagementIds: {
        "!=": "null"
      },
      requirementType: RequirementType.PayoutMethod
    }
  });

  const requirements = queryRequirements.data || [];

  const hasPayoutMethodRequirement = requirements.some(
    requirement => requirement.requirementType === RequirementType.PayoutMethod
  );

  const taxPayeeOnboardingModules: OnboardingModule[] = useMemo(() => {
    const steps: OnboardingModule[] = [
      {
        type: "create_account",
        options: {
          accountTypes: ["Business", "Individual"],
          verificationLevel: "Tax",
          show1099Message: true
        }
      },
      {
        type: "certify_tax_payer_info"
      }
    ];

    if (hasPayoutMethodRequirement) {
      steps.push({
        type: "payout_method"
      });
    }

    return steps;
  }, [hasPayoutMethodRequirement]);

  return (
    <OnboardingFlow
      isLoading={queryRequirements.isInitialLoading}
      basePath={PATH_ONBOARDING_TAX_PAYEE}
      modules={taxPayeeOnboardingModules}
      onSuccess={() => {
        history.push("/member/dashboard");
      }}
    />
  );
};
